import { Box, Flex, Text, Button, Heading, Card, Container } from '@radix-ui/themes';
import { PersonIcon } from '@radix-ui/react-icons';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { getRedirectPath } from '../services/authService';
import { useEffect } from 'react';
import { useConfirmDialog } from '../contexts/confirmDialog';

const HomePage = () => {
  const navigate = useNavigate();
  const account = useSelector(state => state.account);
  const authToken = localStorage.getItem('authToken')
  const user = useSelector((state) => state.user);

  const { showConfirmDialog } = useConfirmDialog();

  useEffect(() => {
    const isAuthenticated = user?.details && account?.details && authToken;
    if (isAuthenticated) {
      navigate(getRedirectPath(user.details.role))
    }
  }, [])

  return (
    <Flex
      direction="column"
      align="center"
      gap="9"
      px="4"
    >
      {/* Hero Section */}
      <Container>
        <Flex direction={{ initial: 'column', md: 'row'}} width="100%" justify="center" maxWidth="1080px" gap="9" align="center">
          <img
              src="/images/girl_graph.png"
              alt="Student studying"
              style={{
                width: '100%',
                minWidth: '250px',
                maxWidth: '400px',
                height: 'auto',
                borderRadius: 'var(--radius-3)',
                objectFit: 'cover',
              }}
            />
            <Flex direction="column" gap="4" align={{ initial: 'center', md: 'start' }} >
              <Box>
                <img src="/edusua.svg" style={{maxWidth:'200px', width:'100%', display:"block"}} />
              </Box>
              <Text>Better measured learning</Text>
              <Flex gap="4">
                <Button
                  onClick={() => navigate('/login')}
                  variant="solid"
                  >
                  Login
                </Button>
                <Button
                  onClick={() => navigate('/register')}
                  variant="solid"
                  >
                  Register
                </Button>
              </Flex>
            </Flex>
        </Flex>
        <Flex direction="row" gap="4" align="stretch" mt="8" display={{ initial: 'none', md: 'flex' }} px="8">
          <Card>
            <Heading size="2">Guardian</Heading>
            <Text size="1">Monitor your child's progress and support their educational journey.</Text>
          </Card>
          <Card variant="classic" style={{backgroundColor: 'var(--blue-5)'}}>
            <Heading size="2">Students</Heading>
            <Text size="1">Access courses, track progress, and engage in meaningful learning.</Text>
          </Card>
          <Card>
            <Heading size="2">Teacher</Heading>
            <Text size="1">Create courses, manage students, and track their performance.</Text>
          </Card>
          <Card>
            <Heading size="2">School</Heading>
            <Text size="1">Oversee schools learning activities, manage teachers, and track student performance.</Text>
          </Card>
        </Flex>
      </Container>

    </Flex>
  );
};

export default HomePage;
